export const GET_COMMENTS = 'GET_COMMENTS';// 获取评论列表
export const GET_COMMENT_TYPE_DIC = 'GET_COMMENT_TYPE_DIC';// 获取评论类型字典
export const GET_COMMENT_TEMPLATES = 'GET_COMMENT_TEMPLATES';// 获取评论模板列表
export const GET_COMMENT_TEMPLATE = 'GET_COMMENT_TEMPLATE';// 获取单个评论模板
export const CREATE_COMMENT_TEMPLATES = 'CREATE_COMMENT_TEMPLATES';// 创建评论模板列表
export const UPDATE_COMMENT_TEMPLATES = 'UPDATE_COMMENT_TEMPLATES';// 更新评论模板列表
export const DELETE_COMMENT_TEMPLATES = 'DELETE_COMMENT_TEMPLATES';// 删除评论模板列表
export const GET_MAJIA_COMMENTS = 'GET_MAJIA_COMMENTS';// 获取马甲评论列表
